import { Locale } from 'locale-enum';
import moment from 'moment';

// prettier-ignore
const SystemTranslations = {
  [Locale.en_US]: {
    DateFormat: {
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      monthsParseExact: true,
      weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      weekdaysParseExact: true,
    },
    RelativeTime: {
      future: 'in %s',
      past: (n: any) => String(n) === 'Just now' ? 'Just now' : `${String(n)} ago`,
      s: 'Just now', ss: '%d seconds',
      m: 'a minute', mm: '%d minutes',
      h: 'an hour', hh: '%d hours',
      d: 'a day', dd: '%d days',
      M: 'a month', MM: '%d months',
      y: 'a year', yy: '%d years',
    },
  },
  [Locale.es_US]: {
    DateFormat: {
      months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
      monthsParseExact: true,
      weekdays: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
      weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
      weekdaysMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
      weekdaysParseExact: true,
    },
    RelativeTime: {
      future: 'en %s',
      past: (value: any) => (value === 'Justo ahora' ? value : `hace ${value}`),
      s: 'Justo ahora', ss: '%d segundos',
      m: 'un minuto', mm: '%d minutos',
      h: 'una hora', hh: '%d horas',
      d: 'un día', dd: '%d días',
      M: 'un mes', MM: '%d meses',
      y: 'un año', yy: '%d años',
    },
  },
  [Locale.fr_CA]: {
    DateFormat: {
      months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
      monthsShort: ['Janv', 'Févr', 'Mars', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
      monthsParseExact: true,
      weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
      weekdaysShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
      weekdaysMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
      weekdaysParseExact: true,
    },
    RelativeTime: {
      future: 'dans %s',
      past: (value: any) => (value === "À l'instant" ? value : `il y a ${value}`),
      s: "À l'instant", ss: '%d secondes',
      m: 'une minute', mm: '%d minutes',
      h: 'une heure', hh: '%d heures',
      d: 'un jour', dd: '%d jours',
      M: 'un mois', MM: '%d mois',
      y: 'un an', yy: '%d ans',
    },
  },
  [Locale.ro_RO]: {
    DateFormat: {
      months: ['Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie', 'Iulie', 'August', 'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie'],
      monthsShort: ['Ian', 'Feb', 'Mart', 'Apr', 'Mai', 'Iun', 'Iul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      monthsParseExact: true,
      weekdays: ['Duminică', 'Luni', 'Marți', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă'],
      weekdaysShort: ['Dum', 'Lun', 'Mar', 'Mie', 'Joi', 'Vin', 'Sâm'],
      weekdaysMin: ['Du', 'Lu', 'Ma', 'Mi', 'Jo', 'Vi', 'Sâ'],
      weekdaysParseExact: true,
    },
    RelativeTime: {
      future: 'peste %s',
      past: (value: any) => (value === 'Chiar acum' ? value : `acum ${value}`),
      s: 'Chiar acum', ss: '%d secunde',
      m: 'un minut', mm: '%d minute',
      h: 'o oră', hh: '%d ore',
      d: 'o zi', dd: '%d zile',
      M: 'o lună', MM: '%d luni',
      y: 'un an', yy: '%d ani',
    },
  },
  [Locale.ru_RU]: {
    DateFormat: {
      months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
      monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
      monthsParseExact: true,
      weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
      weekdaysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      weekdaysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      weekdaysParseExact: true,
    },
    RelativeTime: {
      future: 'через %s',
      past: (value: any) => (value === 'Только что' ? value : `${value} назад`),
      s: 'Только что', ss: '%d секунд',
      m: 'минуту', mm: '%d минут',
      h: 'час', hh: '%d часов',
      d: 'день', dd: '%d дней',
      M: 'месяц', MM: '%d месяцев',
      y: 'год', yy: '%d лет',
    },
  },
  [Locale.ka_GE]: {
    DateFormat: {
      months: ['იანვარი', 'თებერვალი', 'მარტი', 'აპრილი', 'მაისი', 'ივნისი', 'ივლისი', 'აგვისტო', 'სექტემბერი', 'ოქტომბერი', 'ნოემბერი', 'დეკემბერი'],
      monthsShort: ['იან', 'თებ', 'მარ', 'აპრ', 'მაი', 'ივნ', 'ივლ', 'აგვ', 'სექ', 'ოქტ', 'ნოე', 'დეკ'],
      monthsParseExact: true,
      weekdays: ['კვირა', 'ორშაბათი', 'სამშაბათი', 'ოთხშაბათი', 'ხუთშაბათი', 'პარასკევი', 'შაბათი'],
      weekdaysShort: ['კვი', 'ორშ', 'სამ', 'ოთხ', 'ხუთ', 'პარ', 'შაბ'],
      weekdaysMin: ['კვ', 'ორ', 'სა', 'ოთ', 'ხუ', 'პა', 'შა'],
      weekdaysParseExact: true,
    },
    RelativeTime: {
      future: '%s-ში',
      past: (value: any) => (value === 'ახლახანს' ? value : `${value} წინ`),
      s: 'ახლახანს', ss: '%d წამი',
      m: 'წუთი', mm: '%d წუთი',
      h: 'საათი', hh: '%d საათი',
      d: 'დღე', dd: '%d დღე',
      M: 'თვე', MM: '%d თვე',
      y: 'წელი', yy: '%d წელი',
    },
  },
  [Locale.hy_AM]: {
    DateFormat: {
      months: ['հունվար', 'փետրվար', 'մարտ', 'ապրիլ', 'մայիս', 'հունիս', 'հուլիս', 'օգոստոս', 'սեպտեմբեր', 'հոկտեմբեր', 'նոյեմբեր', 'դեկտեմբեր'],
      monthsShort: ['հնվ', 'փտր', 'մրտ', 'ապր', 'մյս', 'հնս', 'հլս', 'օգս', 'սպտ', 'հկտ', 'նմբ', 'դկտ'],
      monthsParseExact: true,
      weekdays: ['կիրակի', 'երկուշաբթի', 'երեքշաբթի', 'չորեքշաբթի', 'հինգշաբթի', 'ուրբաթ', 'շաբաթ'],
      weekdaysShort: ['կրկ', 'երկ', 'երք', 'չրք', 'հնգ', 'ուրբ', 'շբթ'],
      weekdaysMin: ['կրկ', 'երկ', 'երք', 'չրք', 'հնգ', 'ուրբ', 'շբթ'],
      weekdaysParseExact: true,
    },
    RelativeTime: {
      future: '%s հետո',
      past: (value: any) => (value === 'Հենց նոր' ? value : `${value} առաջ`),
      s: 'Հենց նոր', ss: '%d վայրկյան',
      m: 'րոպե', mm: '%d րոպե',
      h: 'ժամ', hh: '%d ժամ',
      d: 'օր', dd: '%d օր',
      M: 'ամիս', MM: '%d ամիս',
      y: 'տարի', yy: '%d տարի',
    },
  },
} as const;

export const translateSystem = (locale: Locale | string) => {
  const trans = SystemTranslations[locale as Locale] ?? SystemTranslations[Locale.en_US];
  moment.locale(locale, {
    ...trans.DateFormat,
    relativeTime: trans.RelativeTime,
  });
};
